import { useEffect, useState } from 'react';

/**
 * Preloads an image URL and returns null if the image fails to load.
 * Prevents broken image icons from appearing when the URL is set
 * but the actual image file is missing (e.g. 404 from CloudFront).
 */
const useValidatedImage = url => {
  const [validUrl, setValidUrl] = useState(url);

  useEffect(
    () => {
      if (!url) {
        setValidUrl(null);
        return;
      }
      const img = new Image();
      img.onload = () => setValidUrl(url);
      img.onerror = () => setValidUrl(null);
      img.src = url;
    },
    [url]
  );

  return validUrl;
};

export default useValidatedImage;
